export default __webpack_public_path__ + "static/media/no account charges-icon.20ab8622.svg";